import { render, staticRenderFns } from "./AdChangelogIcon.vue?vue&type=template&id=4f2b2afa&scoped=true"
import script from "./AdChangelogIcon.vue?vue&type=script&lang=js"
export * from "./AdChangelogIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f2b2afa",
  null
  
)

export default component.exports